const allCards = [

    {
        id: 1,
        width: 4,
        height: 3,
        number: 1,
        color: 'yellow'
    },
    {
        id: 2,
        width: 55,
        height: 3,
        number: 2,
        color: 'yellow'
    },
    {
        id: 3,
        width: 106,
        height: 3,
        number: 3,
        color: 'yellow'
    },
    {
        id: 4,
        width: 157,
        height: 3,
        number: 4,
        color: 'yellow'
    },
    {
        id: 5,
        width: 208,
        height: 3,
        number: 5,
        color: 'yellow'
    },
    {
        id: 6,
        width: 259,
        height: 3,
        number: 6,
        color: 'yellow'
    },
    {
        id: 7,
        width: 310,
        height: 4,
        number: 7,
        color: 'yellow'
    },
    {
        id: 8,
        width: 361,
        height: 3,
        number: 8,
        color: 'yellow'
    },
    {
        id: 9,
        width: 4,
        number: 1,
        height: 134,
        color: 'red'
    },
    {
        id: 10,
        width: 55,
        height: 134,
        number: 2,
        color: 'red'
    },
    {
        id: 11,
        width: 106,
        height: 135,
        number: 3,
        color: 'red'
    },
    {
        id: 12,
        width: 157,
        height: 134,
        number: 4,
        color: 'red'
    },
    {
        id: 13,
        width: 208,
        height: 134,
        number: 5,
        color: 'red'
    },
    {
        id: 14,
        width: 259,
        height: 134,
        number: 6,
        color: 'red'
    },
    {
        id: 15,
        width: 310,
        height: 134,
        number: 7,
        color: 'red'
    },
    {
        id: 16,
        width: 361,
        height: 134,
        number: 8,
        color: 'red'
    },
    {
        id: 17,
        width: 4,
        height: 69,
        number: 1,
        color: 'blue'
    },
    {
        id: 18,
        width: 55,
        height: 69,
        number: 2,
        color: 'blue'
    },
    {
        id: 19,
        width: 106,
        height: 69,
        number: 3,
        color: 'blue'
    },
    {
        id: 20,
        width: 157,
        height: 69,
        number: 4,
        color: 'blue'
    },
    {
        id: 21,
        width: 208,
        height: 69,
        number: 5,
        color: 'blue'
    },
    {
        id: 22,
        width: 259,
        height: 69,
        number: 6,
        color: 'blue'
    },
    {
        id: 23,
        width: 310,
        height: 69,
        number: 7,
        color: 'blue'
    },
    {
        id: 24,
        width: 361,
        height: 69,
        number: 8,
        color: 'blue'
    },

];

export default allCards;